var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProbe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "GPS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-415 217 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_x34__3_",
    d: "M-306.3,293.3l-23.8-15.1l-9.8,9.8l-2-2l9.5-9.5l-3-3l3-3l-8.1-8.1l-3,3l-3-3l-9.5,9.5l-2-2l9.8-9.8 l-15.3-23.9l-23.8-15.1l-24,24l23.9,15.1l15,23.9l9.3-9.3l2,2l-9.3,9.3l14,14l9.3-9.3l2,2l-9.3,9.3l23.9,15.1l15.1,23.9l24-24 L-306.3,293.3z M-404.4,244.5l18-18l18.4,11.6l-18,18L-404.4,244.5z M-371.5,277.4l-11.6-18.4l18-17.8l11.6,18.4L-371.5,277.4z  M-347.4,301.5l18-18l18.4,11.6l-18,18L-347.4,301.5z M-326.1,316l18-18l11.6,18.4l-18,18L-326.1,316z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbe);
export default __webpack_public_path__ + "static/media/probe.c73bf48a40094204a86e33eea71ec1ba.svg";
export { ForwardRef as ReactComponent };